import { gql } from '@apollo/client';
import { PROJECT_PAGE_FRAGMENT } from './projectPageFragment';

const PROJECT_PAGES_PER_PAGE = 25;
export const GET_PROJECT_PAGES = gql`
  query getProjectPages($projectNodeId: ID!, $afterCursor: String) {
    viewer {
      __typename
      id
      project(id: $projectNodeId) {
        id
        pages(
          first: ${PROJECT_PAGES_PER_PAGE}
          after: $afterCursor
        ) {
          __typename
          nodes {
            __typename
            ...ProjectPageFragment
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${PROJECT_PAGE_FRAGMENT}
`;

export default GET_PROJECT_PAGES;
